import { defineStore } from '../../../../../../node_modules/pinia/dist/pinia.mjs?vue3';
import { useCommitModalState } from './composables/use_commit_modal_state.js?vue3';

export const useRevertCommit = defineStore('revertCommit', () => useCommitModalState());
